import { Box, Card, CardContent, CardMedia, Grid, Typography, useMediaQuery, IconButton, Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { PageTitle } from '../../../layoutPages/components/PageTitle';
import { useState, useEffect } from 'react';
import { ImagePop } from '../../../layoutPages/containers/ImagePop';
import { useDispatch } from 'react-redux';
import { changePopUpStates } from '../../../system/Slicer/CommonSlicer';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CloseIcon from '@mui/icons-material/Close';

interface CCAItem {
    name: string;
    images: string[];
}

export function PageCCA() {
    const isPc = useMediaQuery('(min-width:600px)');
    const dispatch = useDispatch();
    const [ccaData, setCcaData] = useState<CCAItem[]>([]);
    const [selectedImage, setSelectedImage] = useState<string>('');
    const [selectedActivity, setSelectedActivity] = useState<CCAItem | null>(null);
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);

    useEffect(() => {
        // 從相片資料夾中獲取聯課活動資料
        const ccaItems: CCAItem[] = [
            { name: "小童軍", images: ["https://www.pkps.edu.hk/photos/cca/小童軍1.jpg", "https://www.pkps.edu.hk/photos/cca/小童軍2.jpg", "https://www.pkps.edu.hk/photos/cca/小童軍3.jpeg"] },
            { name: "手鐘隊", images: ["https://www.pkps.edu.hk/photos/cca/手鐘隊1.JPEG", "https://www.pkps.edu.hk/photos/cca/手鐘隊2.JPG", "https://www.pkps.edu.hk/photos/cca/手鐘隊3.JPEG"] },
            { name: "立體摺紙班", images: ["https://www.pkps.edu.hk/photos/cca/立體摺紙班1.png", "https://www.pkps.edu.hk/photos/cca/立體摺紙班2.png", "https://www.pkps.edu.hk/photos/cca/立體摺紙班3.png"] },
            { name: "合唱團", images: ["https://www.pkps.edu.hk/photos/cca/合唱團1.jpg", "https://www.pkps.edu.hk/photos/cca/合唱團2.jpeg", "https://www.pkps.edu.hk/photos/cca/合唱團3.jpeg"] },
            { name: "書法班", images: ["https://www.pkps.edu.hk/photos/cca/書法班1.JPG", "https://www.pkps.edu.hk/photos/cca/書法班2.JPG", "https://www.pkps.edu.hk/photos/cca/書法班3.JPG"] },
            { name: "氣球扭扭樂", images: ["https://www.pkps.edu.hk/photos/cca/氣球扭扭樂1.JPEG", "https://www.pkps.edu.hk/photos/cca/氣球扭扭樂2.JPEG", "https://www.pkps.edu.hk/photos/cca/氣球扭扭樂3.JPEG"] },
            { name: "閃星星美術小組", images: ["https://www.pkps.edu.hk/photos/cca/閃星星美術小組1.jpg", "https://www.pkps.edu.hk/photos/cca/閃星星美術小組2.jpg", "https://www.pkps.edu.hk/photos/cca/閃星星美術小組3.jpg"] },
            { name: "培僑劇社", images: ["https://www.pkps.edu.hk/photos/cca/培僑劇社.1.JPG", "https://www.pkps.edu.hk/photos/cca/培僑劇社.2.JPG", "https://www.pkps.edu.hk/photos/cca/培僑劇社.3.JPG"] },
            { name: "常識STEAM計劃", images: ["https://www.pkps.edu.hk/photos/cca/常識STEAM計劃1.jpeg", "https://www.pkps.edu.hk/photos/cca/常識STEAM計劃2.jpeg", "https://www.pkps.edu.hk/photos/cca/常識STEAM計劃3.jpeg"] },
            { name: "排球隊", images: ["https://www.pkps.edu.hk/photos/cca/排球隊1.jpg", "https://www.pkps.edu.hk/photos/cca/排球隊2.jpg", "https://www.pkps.edu.hk/photos/cca/排球隊3.jpg"] },
            { name: "棋藝學會", images: ["https://www.pkps.edu.hk/photos/cca/棋藝學會1.jpeg", "https://www.pkps.edu.hk/photos/cca/棋藝學會2.jpeg", "https://www.pkps.edu.hk/photos/cca/棋藝學會3.jpeg"] },
            { name: "童閱繪本樂悠悠", images: ["https://www.pkps.edu.hk/photos/cca/童閱繪本樂悠悠1.jpeg", "https://www.pkps.edu.hk/photos/cca/童閱繪本樂悠悠2.jpg", "https://www.pkps.edu.hk/photos/cca/童閱繪本樂悠悠3.jpg"] },
            { name: "電動積木組裝班", images: ["https://www.pkps.edu.hk/photos/cca/電動積木組裝班1.jpeg", "https://www.pkps.edu.hk/photos/cca/電動積木組裝班2.jpeg", "https://www.pkps.edu.hk/photos/cca/電動積木組裝班3.jpeg", "https://www.pkps.edu.hk/photos/cca/電動積木組裝班4.jpeg"] },
            { name: "電腦基礎應用", images: ["https://www.pkps.edu.hk/photos/cca/電腦基礎應用1.JPEG", "https://www.pkps.edu.hk/photos/cca/電腦基礎應用2.JPEG", "https://www.pkps.edu.hk/photos/cca/電腦基礎應用3.JPEG"] },
            { name: "敲擊樂隊", images: ["https://www.pkps.edu.hk/photos/cca/敲擊樂隊1.JPG", "https://www.pkps.edu.hk/photos/cca/敲擊樂隊2.JPG", "https://www.pkps.edu.hk/photos/cca/敲擊樂隊3.JPG"] },
            { name: "輕輕鬆鬆DIY", images: ["https://www.pkps.edu.hk/photos/cca/輕輕鬆鬆DIY1.jpg", "https://www.pkps.edu.hk/photos/cca/輕輕鬆鬆DIY2.jpg", "https://www.pkps.edu.hk/photos/cca/輕輕鬆鬆DIY3.png"] },
            { name: "數學A計劃", images: ["https://www.pkps.edu.hk/photos/cca/數學A計劃1.jpg", "https://www.pkps.edu.hk/photos/cca/數學A計劃2.jpg", "https://www.pkps.edu.hk/photos/cca/數學A計劃3.jpeg", "https://www.pkps.edu.hk/photos/cca/數學A計劃4.jpeg"] },
            { name: "趣味摺紙", images: ["https://www.pkps.edu.hk/photos/cca/趣味摺紙1.jpg", "https://www.pkps.edu.hk/photos/cca/趣味摺紙2.jpg", "https://www.pkps.edu.hk/photos/cca/趣味摺紙3.jpg"] },
            { name: "魔術班", images: ["https://www.pkps.edu.hk/photos/cca/魔術班1.JPG", "https://www.pkps.edu.hk/photos/cca/魔術班2.JPG", "https://www.pkps.edu.hk/photos/cca/魔術班3.JPG"] },
            { name: "ARTmazing校園藝術大使", images: ["https://www.pkps.edu.hk/photos/cca/ARTmazing校園藝術大使1.JPG", "https://www.pkps.edu.hk/photos/cca/ARTmazing校園藝術大使2.jpg", "https://www.pkps.edu.hk/photos/cca/ARTmazing校園藝術大使3.jpg"] },
            { name: "English KOL", images: ["https://www.pkps.edu.hk/photos/cca/English KOL 1.jpg", "https://www.pkps.edu.hk/photos/cca/English KOL 2.jpg", "https://www.pkps.edu.hk/photos/cca/English KOL 3.jpg"] },
            { name: "K-pop之星", images: ["https://www.pkps.edu.hk/photos/cca/K-pop之星1.JPG", "https://www.pkps.edu.hk/photos/cca/K-pop之星2.JPG"] },
            { name: "Radio Drama", images: ["https://www.pkps.edu.hk/photos/cca/Radio Drama 1.jpeg", "https://www.pkps.edu.hk/photos/cca/Radio Drama 2.jpeg", "https://www.pkps.edu.hk/photos/cca/Radio Drama 3.jpeg"] }
        ];
        setCcaData(ccaItems);
    }, []);

    const handleImageClick = (activity: CCAItem) => {
        setSelectedActivity(activity);
        setCurrentImageIndex(0);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setSelectedActivity(null);
        setCurrentImageIndex(0);
    };

    const handlePreviousImage = () => {
        if (selectedActivity) {
            setCurrentImageIndex((prev) => 
                prev === 0 ? selectedActivity.images.length - 1 : prev - 1
            );
        }
    };

    const handleNextImage = () => {
        if (selectedActivity) {
            setCurrentImageIndex((prev) => 
                prev === selectedActivity.images.length - 1 ? 0 : prev + 1
            );
        }
    };

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <Grid item xs={11} sm={10}>
                <PageTitle 
                    title='聯課活動 | CCA' 
                    size='h3' 
                    subtitle={{ title: 'CO-CURRICULAR ACTIVITIES', size: 'h5' }} 
                />
                
                <Typography variant="body1" sx={{ mb: 3, textAlign: 'center', color: 'text.secondary' }}>
                    本校提供多元化的聯課活動，讓學生在課餘時間發展個人興趣和才能，培養團隊合作精神。
                </Typography>

                <Grid container spacing={3}>
                    {ccaData.map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card 
                                sx={{ 
                                    height: '100%', 
                                    display: 'flex', 
                                    flexDirection: 'column',
                                    transition: 'transform 0.2s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: 3
                                    }
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={item.images[0]}
                                    alt={item.name}
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => handleImageClick(item)}
                                />
                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Typography gutterBottom variant="h6" component="div" sx={{ textAlign: 'center' }}>
                                        {item.name}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            
            {/* 相片輪播對話框 */}
            <Dialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        color: 'white'
                    }
                }}
            >
                <DialogContent sx={{ p: 0, position: 'relative' }}>
                    {selectedActivity && (
                        <>
                            {/* 相片顯示區域 */}
                            <Box
                                sx={{
                                    position: 'relative',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '70vh',
                                    p: 2
                                }}
                            >
                                <img
                                    src={selectedActivity.images[currentImageIndex]}
                                    alt={`${selectedActivity.name} - 相片 ${currentImageIndex + 1}`}
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '70vh',
                                        objectFit: 'contain',
                                        borderRadius: '8px'
                                    }}
                                />
                                
                                {/* 上一張按鈕 */}
                                {selectedActivity.images.length > 1 && (
                                    <IconButton
                                        onClick={handlePreviousImage}
                                        sx={{
                                            position: 'absolute',
                                            left: 16,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                            color: 'white',
                                            '&:hover': {
                                                backgroundColor: 'rgba(0, 0, 0, 0.7)'
                                            }
                                        }}
                                    >
                                        <NavigateBeforeIcon fontSize="large" />
                                    </IconButton>
                                )}
                                
                                {/* 下一張按鈕 */}
                                {selectedActivity.images.length > 1 && (
                                    <IconButton
                                        onClick={handleNextImage}
                                        sx={{
                                            position: 'absolute',
                                            right: 16,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                            color: 'white',
                                            '&:hover': {
                                                backgroundColor: 'rgba(0, 0, 0, 0.7)'
                                            }
                                        }}
                                    >
                                        <NavigateNextIcon fontSize="large" />
                                    </IconButton>
                                )}
                            </Box>
                            
                            {/* 相片資訊 */}
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                                <Typography variant="h6" sx={{ mb: 1 }}>
                                    {selectedActivity.name}
                                </Typography>
                                <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
                                    {currentImageIndex + 1} / {selectedActivity.images.length}
                                </Typography>
                            </Box>
                        </>
                    )}
                </DialogContent>
                
                <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
                    <Button
                        onClick={handleCloseDialog}
                        startIcon={<CloseIcon />}
                        variant="outlined"
                        sx={{ color: 'white', borderColor: 'white' }}
                    >
                        關閉
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}
